import { Injectable } from '@angular/core';
import { HttpParams } from "@angular/common/http";


@Injectable({
  providedIn: 'root'
})
export class UtilsService {


  /**
   * @param statuses
   */
  static buildUrl(statuses: string[] | undefined): HttpParams | undefined {

    let params = new HttpParams();

    if (statuses && statuses.length > 0) {
      statuses.forEach(status => {
        params = params.append('status', status);
      });
    }

    return params;

  }



}
